import { useCallback } from 'react';
import { useRemoveTagFromPipeline, useQueryPipelineTags, isAllowedToWriteTags, useTrackWithUser } from '@ion/api';

import transformPipelineTagsToChips from 'app/shared/components/tags/transformPipelineTagsToChips';

const CHIP_PROPS = { variant: 'soft', color: 'primary' };
const STACK_PROPS = { 'data-test-id': 'pipelineTags' };

export default function useEditablePipelineTags({ pipelineId }) {
  const canEdit = isAllowedToWriteTags();
  // Prevent loading from flashing true on refetch after tag mutations
  const { data: tags, loading } = useQueryPipelineTags({
    pipelineId,
    notifyOnNetworkStatusChange: false,
  });
  const [trackTagRemoved] = useTrackWithUser('pipeline_tag_removed_from_pipeline');
  const [removeTagFromPipeline] = useRemoveTagFromPipeline({ onCompleted: () => trackTagRemoved() });

  const chips = transformPipelineTagsToChips(tags);

  const handleDelete = useCallback(
    chip => {
      removeTagFromPipeline({ pipelineId, tag: chip });
    },
    [pipelineId, removeTagFromPipeline]
  );

  return {
    canEdit,
    tags,
    loading,
    chips,
    ChipProps: CHIP_PROPS,
    StackProps: STACK_PROPS,
    handleDelete: canEdit ? handleDelete : null,
  };
}
